var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2044_19430)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2044_19430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0127 26.175L10.4436 26.4297C12.2531 27.5016 14.3279 28.0686 16.4438 28.0696H16.4482C22.946 28.0696 28.2341 22.7927 28.2368 16.307C28.238 13.1641 27.0129 10.2086 24.7871 7.98539C23.6955 6.88897 22.3968 6.01954 20.9662 5.42745C19.5356 4.83536 18.0016 4.53236 16.4528 4.53599C9.95007 4.53599 4.66176 9.81226 4.65945 16.2976C4.65624 18.5121 5.28106 20.6824 6.46167 22.5574L6.74215 23.0023L5.55102 27.3425L10.0127 26.175ZM2.14551 30.7049L4.15785 23.3717C2.91679 21.2256 2.26387 18.7909 2.26464 16.2966C2.26792 8.49353 8.63016 2.14539 16.4484 2.14539C20.2424 2.14731 23.8034 3.62092 26.4816 6.2959C29.1598 8.97088 30.6333 12.5265 30.632 16.308C30.6285 24.1105 24.2653 30.4598 16.4482 30.4598H16.4421C14.0685 30.4588 11.7361 29.8645 9.66438 28.737L2.14551 30.7049Z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 30.5595L4.01235 23.2262C2.76914 21.075 2.11613 18.6346 2.11913 16.1512C2.12241 8.34808 8.48465 1.99994 16.3029 1.99994C20.0968 2.00186 23.6579 3.47548 26.3361 6.15046C29.0143 8.82544 30.4878 12.381 30.4865 16.1625C30.483 23.965 24.1198 30.3143 16.3027 30.3143H16.2965C13.9229 30.3134 11.5906 29.7191 9.51888 28.5916L2 30.5595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3071 4.39047C9.80431 4.39047 4.516 9.66674 4.51368 16.1521C4.51048 18.3666 5.1353 20.5369 6.31591 22.4119L6.59639 22.8569L5.40525 27.1972L9.86715 26.0295L10.298 26.2842C12.1075 27.3561 14.1824 27.9229 16.2982 27.9241H16.3027C22.8004 27.9241 28.0887 22.6472 28.0912 16.1615C28.0961 14.6157 27.7938 13.0842 27.2016 11.6558C26.6095 10.2274 25.7394 8.93036 24.6416 7.83988C23.5499 6.74342 22.2511 5.87399 20.8205 5.2819C19.3899 4.6898 17.8558 4.38682 16.3071 4.39047Z",
    fill: "url(#paint0_linear_2044_19430)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.758 10.2349C12.4923 9.646 12.2128 9.63407 11.9605 9.62387L11.2812 9.6156C11.0448 9.6156 10.6608 9.70411 10.3362 10.0581C10.0116 10.4121 9.0957 11.2678 9.0957 13.008C9.0957 14.7483 10.3657 16.4299 10.5426 16.6662C10.7196 16.9025 12.9943 20.5876 16.5967 22.0054C19.5902 23.1837 20.1994 22.9493 20.8494 22.8904C21.4994 22.8316 22.9462 22.0348 23.2413 21.2088C23.5364 20.3829 23.5366 19.6752 23.4482 19.5272C23.3597 19.3793 23.1233 19.2914 22.7686 19.1143C22.4139 18.9373 20.6718 18.0817 20.347 17.9636C20.0222 17.8454 19.7861 17.7868 19.5495 18.1408C19.313 18.4948 18.6346 19.2912 18.4278 19.5272C18.2209 19.7633 18.0145 19.7929 17.6598 19.6161C17.3051 19.4393 16.1639 19.0657 14.8098 17.8606C13.7564 16.9231 13.0452 15.7652 12.8382 15.4114C12.6311 15.0575 12.8162 14.8659 12.9939 14.6897C13.153 14.5311 13.3483 14.2766 13.5258 14.0701C13.7033 13.8637 13.7617 13.7161 13.8797 13.4804C13.9977 13.2447 13.9389 13.0377 13.8502 12.8609C13.7616 12.684 13.073 10.9345 12.758 10.2349Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2044_19430",
    x: -0.854492,
    y: -0.854614,
    width: 34.4863,
    height: 34.5595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_2044_19430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2044_19430",
    x1: 16.0625,
    y1: 5.80271,
    x2: 16.1815,
    y2: 25.9136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_19430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b93049354f5b9c4f105e8117b86edeab.svg";
export { ForwardRef as ReactComponent };